export enum CmpConfigPublisherCustomPurposeVendorField {
    NAME = "name",
    POLICY_URL = "policyUrl",
}
